export default class RelatedPosts {
    scrollTop;
    constructor(){
        const that = this;
        document.addEventListener('click', function(e) {
            var target = e.target;
            if (target.matches('.related-posts--pagination a.page-numbers')) {
                e.preventDefault();
                let pageNumber = target.textContent,
                    related_posts_container = document.querySelector('.related-posts--container'),
                    perPage = related_posts_container.getAttribute('data-perpage'),
                    postId = related_posts_container.getAttribute('data-postid'),
                    templateId = related_posts_container.getAttribute('data-template'),
                    random = related_posts_container.getAttribute('data-rand'),
                    orderby = related_posts_container.getAttribute('data-orderby'),
                    catnot = related_posts_container.getAttribute('data-catnot'),
                    maxpage = related_posts_container.getAttribute('data-maxpage'),
                    single = related_posts_container.getAttribute('data-signle'),
                    xhr = new XMLHttpRequest();
                xhr.open('POST', '/wp-admin/admin-ajax.php');
                xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            let response = JSON.parse(xhr.responseText);
                            related_posts_container.innerHTML = response.content;
                            related_posts_container.classList.remove('loading');
                            let currentPosition = related_posts_container.scrollTop;

                            that.scrollTop = related_posts_container.getBoundingClientRect().top + window.pageYOffset - 220;
                            setTimeout(() => {
                                that.animatedScroll();
                            }, 500);

                        } else {
                            console.log(xhr.status);
                        }
                    }
                };
                xhr.onerror = function(err) {
                    console.log(err);
                    related_posts_container.classList.remove('loading');
                };
                xhr.send(`action=related_posts_pagination&pageNumber=${pageNumber}&perPage=${perPage}&templateId=${templateId}&postId=${postId}&rand=${random}&orderby=${orderby}&cat_not=${catnot}&max_page=${maxpage}&single=${single}`);
                related_posts_container.classList.add('loading');
            }
        });
    }

    animatedScroll() {
        const scrollTop = this.scrollTop;
        const scrollOptions = {
            top: scrollTop,
            behavior: 'smooth',
        };

        window.scrollTo(scrollOptions);
    }
}
